const LanguagesIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
        fill="#85C553"
      />
      <g clipPath="url(#clip0_1713_2652)">
        <path d="M17.7776 22.6665L16.8887 25.4221H18.6664L17.7776 22.6665Z" fill="#F3F9EE" />
        <path
          d="M34.9338 10.6665H20.7116V15.1109H24.2671V16.8887H12.7116C11.2005 16.8887 10.0449 18.0443 10.0449 19.5554V29.3332C10.0449 30.8443 11.2005 31.9998 12.7116 31.9998H13.6005V36.5332L19.2005 31.9998H25.156V25.7776H34.9338C36.4449 25.7776 37.6005 24.6221 37.6005 23.1109V13.3332C37.6005 11.8221 36.4449 10.6665 34.9338 10.6665ZM19.6449 28.3554L19.2005 26.9332H16.4449L15.9116 28.3554H13.7783L16.7116 20.4443H18.8449L21.7783 28.3554H19.6449ZM33.156 21.3332V23.1109C32.0005 23.1109 30.756 22.7554 29.6894 22.2221C28.6227 22.7554 27.3783 23.0221 26.1338 23.1109L26.0449 21.3332C26.6671 21.3332 27.2894 21.2443 27.9116 21.0665C27.1116 20.2665 26.5783 19.2887 26.3116 18.2221H28.1783C28.4449 19.0221 28.9783 19.6443 29.6005 20.1776C30.5783 19.3776 31.2005 18.2221 31.2894 16.8887H25.956V15.1109H28.6227V13.3332H30.4005V15.1109H33.3338L33.4227 15.9998C33.5116 17.8665 32.8005 19.7332 31.4671 21.0665C32.0894 21.2443 32.6227 21.3332 33.156 21.3332Z"
          fill="#F3F9EE"
        />
      </g>
      <defs>
        <clipPath id="clip0_1713_2652">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LanguagesIcon;
